import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import type { LabEntry } from '../../models/careOSPrototype';

/**
 * Fetches a patient's prior lab results (GET /private/careos/labs/:patientId/history).
 * The labs view seeds local editable state from this and then mutates client-side
 * (the order/upload flow has no backend yet), so consumers read-through with a
 * local override rather than re-seeding on refetch.
 */
export const useLabHistory = (patientId: string) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const { data, isLoading, isError } = useQuery<LabEntry[], Error>({
    queryKey: ['careos-lab-history', patientId, userToken],
    queryFn: () =>
      api({ route: `/private/careos/labs/${patientId}/history`, token: userToken }),
    enabled: isAuthenticated && !loading && !!userToken && !!patientId,
    refetchOnWindowFocus: false,
  });

  return { history: data ?? [], isLoading, isError };
};
